import React, { useEffect, useRef } from "react";
import "./PapayaHome.scss"
import Button from "../components/Button/Button";
import exp from "../assets/exp.svg"
import tick from "../assets/tick.svg"
import chilli from "../assets/chilli.svg"
import { useDispatch, useSelector } from "react-redux";
import { sortByOrderAscending } from "../helper/helper";
import { setIsComing } from "../../../../../../redux/companyDataSlice";
import { useHistory } from "react-router";
import ThreeDotSlider from "../components/ThreeDotSlider/ThreeDotSlider ";
import CustomVideoPlayer from "../components/CustomVideoPlayer/CustomVideoPlayer";
const PapayaHome = () => {
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "home")
    const dispatch = useDispatch()
    const Components = page?.Components || []

    const containerRef = useRef(null);
    const contentRef = useRef(null);
    const containerRef2 = useRef(null);
    const contentRef2 = useRef(null);
    const history = useHistory()
    useEffect(() => {
        const container = containerRef.current;
        const content = contentRef.current;

        if (!container || !content) return;

        let scrollLeft = 0;
        let animationFrame;

        const clone = content.cloneNode(true);
        container.appendChild(clone);

        const animate = () => {
            scrollLeft += 0.5;
            if (scrollLeft >= content.scrollWidth) {
                scrollLeft = 0;// Reset seamlessly
            }
            container.scrollLeft = scrollLeft;
            animationFrame = requestAnimationFrame(animate);
        };

        animationFrame = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationFrame);
    }, []);
    useEffect(() => {
        const container = containerRef2.current;
        const content = contentRef2.current;

        if (!container || !content) return;

        let scrollLeft = 0;
        let animationFrame;

        const clone = content.cloneNode(true);
        container.appendChild(clone);

        const animate = () => {
            scrollLeft += 0.5;
            if (scrollLeft >= content.scrollWidth) {
                scrollLeft = 0;// Reset seamlessly
            }
            container.scrollLeft = scrollLeft;
            animationFrame = requestAnimationFrame(animate);
        };

        animationFrame = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationFrame);
    }, []);
    const BoldText = ({ text }) => {
        const parts = text?.split(/\*\*/);

        return (
            <div className="PapayaHome-Content-right-content">
                {parts.map((part, index) =>
                    index % 2 === 1 ? <b key={index}>{part}</b> : part
                )}
            </div>
        );
    };
    const getRightContent5Components = (component) => {
        switch (component.ID) {
            case "PapayaHome-Content5-right-subheader":
                return <div className="PapayaHome-Content5-right-subheader">
                    {component?.Props?.text}
                </div>
            case "PapayaHome-Content5-right-header":
                return <div className="PapayaHome-Content5-right-header">
                    <span className="PapayaHome-Content5-right-header">
                        {component?.Props?.header}
                    </span>
                    <span className="PapayaHome-Content5-right-header-2"> {component?.Props?.headerHighlight}</span>
                </div>
            case "PapayaHome-Content5-right-content":
                return <div className="PapayaHome-Content5-right-content">
                    {component?.Props?.content}
                </div>
            case "PapayaHome-Content5-right-list":
                return <div className="PapayaHome-Content5-right-list">
                    {component?.Data.map((value, key) => {
                        return (
                            <>
                                <div className="PapayaHome-Content5-right-list-item">
                                    <img alt="" className="PapayaHome-Content5-right-list-item-img" src={value?.icon} />
                                    <div className="PapayaHome-Content5-right-list-item-text">{value?.text}</div>
                                </div>
                                {key !== component?.Data.length - 1 && <div className="PapayaHome-Content5-right-list-sperator" />}
                            </>


                        )
                    })}
                </div>
            case "PapayaHome-Content5-right-button":
                return <Button
                    isArrow={component?.Props?.isArrow}
                    text={component?.Props?.btnText}
                    onClick={() => {
                        if (component?.Props?.href && component?.Props?.href?.includes("https://")) {
                            window.open(component?.Props?.href, '_blank')
                        } else {
                            dispatch(setIsComing(true))
                        }
                    }} />
            default:
                return <div />
        }

    }
    const getRightContent5Content = (components) => {
        return (
            <div className="PapayaHome-Content5-right">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getRightContent5Components(component)
                    )
                })}
            </div>
        )
    }
    const getLeftContent5Content = (props) => {
        return (
            <div className="PapayaHome-Content5-left">
                <img className="PapayaHome-Content5-left-img" alt="" src={props?.src} />
                <div className="PapayaHome-Content5-left-cont">
                    <div className="PapayaHome-Content5-left-cont-header">{props?.header}</div>
                    <div className="PapayaHome-Content5-left-cont-subheader">{props?.subheader}</div>
                    <div className="PapayaHome-Content5-left-cont-list">
                        <img className="PapayaHome-Content5-left-cont-list-img"
                            alt=""
                            src='https://images.unsplash.com/photo-1672863601285-253fc82db868?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fHVzZXJzfGVufDB8fDB8fHww' />

                        <img className="PapayaHome-Content5-left-cont-list-img2"
                            alt=""
                            src='https://plus.unsplash.com/premium_photo-1690407617542-2f210cf20d7e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cGVyc29ufGVufDB8fDB8fHww' />
                        <img className="PapayaHome-Content5-left-cont-list-img2"
                            alt=""
                            src='https://images.unsplash.com/photo-1491349174775-aaafddd81942?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTZ8fHBlcnNvbnxlbnwwfHwwfHx8MA%3D%3D' />
                        <div className="PapayaHome-Content5-left-cont-list-img2">
                            +
                        </div>
                    </div>

                </div>
            </div>
        )
    }
    const getContent5Component = (component) => {
        switch (component.ID) {
            case "PapayaHome-Content5-left":
                return getLeftContent5Content(component?.Props)
            case "PapayaHome-Content5-right":
                return getRightContent5Content(component?.Components)
            default:
                return <div />
        }

    }
    const getHomeContent5 = (components) => {
        return (
            <div className="PapayaHome-Content5">
                <img alt="" className="PapayaHome-Content5-chilli"
                    src={chilli} />
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getContent5Component(component)
                    )
                })}
            </div>
        )
    }
    const getHomeContent3Component = (component) => {
        switch (component.ID) {
            case "PapayaHome-Content3-subheader":
                return <div className="PapayaHome-Content3-subheader">
                    {component?.Props?.text}
                </div>
            case "PapayaHome-Content3-header":
                return <div className="PapayaHome-Content3-header">
                    <span className="PapayaHome-Content3-header">{component?.Props?.header}</span>
                    <span className="PapayaHome-Content3-header-2"> {component?.Props?.headerHighlight}</span>

                </div>
            case "PapayaHome-Content3-grid":
                return <div className="PapayaHome-Content3-grid">
                    {component?.Data.map((data, key) => {
                        return (
                            <div key={key} className="PapayaHome-Content3-grid-item">
                                <img
                                    className="PapayaHome-Content3-grid-item-img"
                                    alt=""
                                    src={data?.src} />
                                <div
                                    className="PapayaHome-Content3-grid-item-name">
                                    {data?.name}
                                </div>
                                <div
                                    className="PapayaHome-Content3-grid-item-des">
                                    {data?.description}
                                </div>
                            </div>
                        )
                    })}

                </div>
            default:
                return <div />
        }

    }
    const getHomeContent3 = (components) => {
        return (
            <div className="PapayaHome-Content3">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getHomeContent3Component(component)
                    )
                })}
            </div>
        )
    }
    const getHomeContent4Component = (component) => {
        switch (component.ID) {
            case "PapayaHome-Content4-subheader":
                return <div className="PapayaHome-Content4-subheader">
                    {component?.Props?.text}
                </div>
            case "PapayaHome-Content4-header":
                return <div className="PapayaHome-Content4-header">
                    <span className="PapayaHome-Content4-header">{component?.Props?.header}</span><br />
                    <span className="PapayaHome-Content4-header-2"> {component?.Props?.headerHighlight}</span>

                </div>
            case "PapayaHome-Content4-list":
                return <div className="PapayaHome-Content4-list">
                    {component?.Data.map((item, key) => {
                        return (
                            <div key={key} className="PapayaHome-Content4-list-item">
                                <img
                                    className="PapayaHome-Content4-list-item-img"
                                    alt=""
                                    src={item?.src} />
                                <div className="PapayaHome-Content4-list-item-right">
                                    <div className="PapayaHome-Content4-list-item-right-top">
                                        <div
                                            className="PapayaHome-Content4-list-item-right-top-name">
                                            {item?.name}
                                        </div>
                                        <span className="PapayaHome-Content4-list-item-right-top-dots"></span>
                                        <div className="PapayaHome-Content4-list-item-right-top-price">
                                            {item?.price}
                                        </div>
                                    </div>
                                    <div
                                        className="PapayaHome-Content4-list-item-right-des">
                                        {item?.description}
                                    </div>
                                    <div
                                        className="PapayaHome-Content4-list-item-right-price">
                                        {item?.price}
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                </div>
            case "PapayaHome-Content4-link":
                return <div className="PapayaHome-Content4-link">
                    <span className="PapayaHome-Content4-link">{component?.Props?.text}</span>
                    <span className="PapayaHome-Content4-link-2"
                        onClick={() => {
                            history.push("/menu")
                        }}>{component?.Props?.textHighlight}</span>

                </div>
            default:
                return <div />
        }

    }
    const getHomeContent4 = (components) => {
        return (
            <div className="PapayaHome-Content4">
                <img alt="" className="PapayaHome-Content4-chilli"
                    src={chilli} />
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getHomeContent4Component(component)
                    )
                })}
            </div>
        )
    }
    const getHomeTestimonialsComponent = (component) => {
        switch (component.ID) {
            case "PapayaHome-Testimonials-subheader":
                return <div className="PapayaHome-Testimonials-subheader">
                    {component?.Props?.text}
                </div>
            case "PapayaHome-Testimonials-header":
                return <div className="PapayaHome-Testimonials-header">
                    <div className="div1">    {component?.Props?.header}

                    </div><div className="div2">    {component?.Props?.headerHighlight}</div>

                </div>
            case "PapayaHome-Testimonials-list":
                return <>
                    <ThreeDotSlider
                        slides={component?.Data} />

                </>
            default:
                return <div />
        }

    }
    const getHomeTestimonials = (src, components) => {
        return (
            <div className="PapayaHome-Testimonials"
                style={{
                    backgroundImage: ` linear-gradient(rgba(14, 17, 13, 0.7), rgba(14, 17, 13, 0.7)), url(${src})`
                }} >
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getHomeTestimonialsComponent(component)
                    )
                })}
            </div>
        )
    }

    const getImagesCarousel = (data) => {
        return (
            <div className="PapayaHome-ImageCarousel" ref={containerRef}>
                <div className="PapayaHome-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        data?.src.includes(".mp4") ?
                            <CustomVideoPlayer
                                src={data?.src} /> : <img key={index} src={data?.src} alt={`img-${index}`} className="PapayaHome-Cont-image" />

                    ))}
                </div>
            </div>
        )
    }
    const getImagesCarousel2 = (data) => {
        return (
            <div className="PapayaHome-ImageCarousel" ref={containerRef2}>
                <div className="PapayaHome-Cont" ref={contentRef2}>
                    {data?.map((data, index) => (<img key={index} src={data?.src} alt={`img-${index}`} className="PapayaHome-Cont-image2" />

                    ))}
                </div>
            </div>
        )
    }
    const getVideoPlayer = (src, data) => {
        return (

            <>
                <div className="PapayaHome-Video">
                    <video className='react-video-player'
                        style={{ height: "100%", width: "100%", objectFit: 'cover' }} autoPlay={true} loop={true} muted={true} controls={false} src={src} />

                    <div className="PapayaHome-Video-overlay"></div>
                </div>
                {getImagesCarousel2(data)}</>
        )
    }
    const getHomeContentList = (components) => {
        return (
            <div className="PapayaHome-Content2">
                {components?.map((data, key) => {
                    return (
                        <div className="PapayaHome-Content2-List" key={key}>
                            <div className="PapayaHome-Content2-List-left">
                                <img alt="" src={data?.icon} />
                            </div>
                            <div className="PapayaHome-Content2-List-right">
                                <div className="PapayaHome-Content2-List-right-header">
                                    {data?.header}
                                </div>
                                <div className="PapayaHome-Content2-List-right-subheader">
                                    {data?.subheader}
                                </div>
                            </div>


                        </div>
                    )
                })}
            </div>
        )
    }
    const getHomeContent6List = (components) => {
        return (
            <div className="PapayaHome-Content6">
                {components?.map((data, key) => {
                    return (
                        <div className="PapayaHome-Content6-List" key={key}>
                            <div className="PapayaHome-Content6-List-left">
                                <img alt="" src={data?.icon} />
                            </div>
                            <div className="PapayaHome-Content6-List-right">
                                <div className="PapayaHome-Content6-List-right-header">
                                    {data?.header}
                                </div>
                                <div className="PapayaHome-Content6-List-right-subheader">
                                    {data?.subheader}
                                </div>
                            </div>


                        </div>
                    )
                })}
            </div>
        )
    }
    const getRightAboutComponents = (component) => {
        switch (component.ID) {
            case "PapayaHome-Content-right-subheader":
                return <div className="PapayaHome-Content-right-subheader">
                    {component?.Props?.text}
                </div>
            case "PapayaHome-Content-right-header":
                return <div className="PapayaHome-Content-right-header">
                    <span className="PapayaHome-Content-right-header">
                        {component?.Props?.header}
                    </span>
                    <span className="PapayaHome-Content-right-header-2"> {component?.Props?.headerHighlight}</span>
                </div>
            case "PapayaHome-Content-right-content":
                return <BoldText text={component?.Props?.content}
                />
            case "PapayaHome-Content-right-list":
                return <div className="PapayaHome-Content-right-list">
                    {component?.Data.map((value, key) => {
                        return (
                            <div className="PapayaHome-Content-right-list-item" key={key}>
                                <div className="PapayaHome-Content-right-list-item-check">
                                    <img alt="" src={tick} /></div>   {value.text}
                            </div>
                        )
                    })}
                </div>
            case "PapayaHome-Content-right-button":
                return <Button
                    isArrow={component?.Props?.isArrow}
                    text={component?.Props?.btnText}
                    onClick={() => {
                        history.push('/about')
                    }} />
            default:
                return <div />
        }

    }
    const getVoucherComponents = (component) => {
        switch (component.ID) {
            case "PapayaHome-Voucher-subheader":
                return <div className="PapayaHome-Voucher-subheader">
                    {component?.Props?.text}
                </div>
            case "PapayaHome-Voucher-header":
                return <div className="PapayaHome-Voucher-header">
                    <span className="PapayaHome-Voucher-header">
                        {component?.Props?.header}
                    </span>
                    <span className="PapayaHome-Voucher-header-2"> {component?.Props?.headerHighlight}</span>
                </div>
            case "PapayaHome-Voucher-content":
                return <div className="PapayaHome-Voucher-content">
                    {component?.Props?.content}
                </div>
            case "PapayaHome-Voucher-button":
                return <Button
                    isArrow={component?.Props?.isArrow}
                    text={component?.Props?.btnText}
                    onClick={() => {
                        if (component?.Props?.href && component?.Props?.href?.includes("https://")) {
                            window.open(component?.Props?.href, '_blank')
                        } else {
                            dispatch(setIsComing(true))
                        }
                    }} />
            default:
                return <div />
        }

    }
    const getVoucherContent = (src, components) => {
        return (
            <div className="PapayaHome-Voucher"
                style={{
                    backgroundImage: ` linear-gradient(rgba(14, 17, 13, 0.5), rgba(14, 17, 13, 0.5)), url(${src})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getVoucherComponents(component)
                    )
                })}
            </div>
        )
    }
    const getRightAboutContent = (components) => {
        return (
            <div className="PapayaHome-Content-right">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getRightAboutComponents(component)
                    )
                })}
            </div>
        )
    }
    const getLeftAboutContent = (props) => {
        return (
            <div className="PapayaHome-Content-left">
                <img alt="" src={props.src} className="PapayaHome-Content-left-img" />
                <div className="PapayaHome-Content-left-exp">
                    <img alt="" src={exp} className="PapayaHome-Content-left-exp-img" />
                    {props.text}
                </div>
                <div className="PapayaHome-Content-left-chef">
                    <img alt="" src={props.chefSrc} className="PapayaHome-Content-left-chef-img" />

                </div>
            </div>
        )
    }
    const getAboutComponent = (component) => {
        switch (component.ID) {
            case "PapayaHome-Content-left":
                return getLeftAboutContent(component?.Props)
            case "PapayaHome-Content-right":
                return getRightAboutContent(component?.Components)
            default:
                return <div />
        }

    }
    const getAboutContent = (components) => {
        return (
            <div className="PapayaHome-Content">
                <img alt="" className="PapayaHome-Content-chilli"
                    src={chilli} />
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getAboutComponent(component)
                    )
                })}
            </div>
        )
    }
    const getLeftHeroContentComponents = (component) => {
        switch (component.ID) {
            case "PapayaHome-Hero-overlay-left-subheader":
                return <div className="PapayaHome-Hero-overlay-left-subheader">
                    {component?.Props?.text}
                </div>
            case "PapayaHome-Hero-overlay-left-header":
                return <div className="PapayaHome-Hero-overlay-left-header">
                    <span className="PapayaHome-Hero-overlay-left-header">
                        {component?.Props?.header}
                    </span>
                    <span className="PapayaHome-Hero-overlay-left-header-2"> {component?.Props?.headerHighlight}</span>
                </div>
            case "PapayaHome-Hero-overlay-left-content":
                return <>
                    <div className="PapayaHome-Hero-overlay-left-content">
                        {component?.Props?.content}
                    </div>{
                        window.screen.width < 900 &&
                        <div className="PapayaHome-Hero-overlay-left-btn-content2">
                            {sortByOrderAscending(component?.Components).map((data, key) => {
                                return (
                                    data?.Props?.isMobile && <Button
                                        isArrow={data?.Props?.isArrow}
                                        text={data?.Props?.btnText}
                                        isPrimary={data?.Props?.isPrimary}
                                        width={"max-content"}
                                        onClick={() => {
                                            if (data?.Props?.href && data?.Props?.href?.includes("https://")) {
                                                window.open(data?.Props?.href, '_blank')
                                            } else {
                                                dispatch(setIsComing(true))
                                            }
                                        }} />

                                )
                            })}

                        </div>}
                </>
            case "PapayaHome-Hero-overlay-left-btn-content":
                return <div className="PapayaHome-Hero-overlay-left-btn-content"> {sortByOrderAscending(component?.Components).map((data, key) => {
                    return (<Button
                        isArrow={window.screen.width < 900 ? false : data?.Props?.isArrow}
                        text={window.screen.width < 900 ? data?.Props?.mobileText : data?.Props?.btnText}
                        isPrimary={data?.Props?.isPrimary}
                        width={window.screen.width < 900 ? "45%" : "max-content"}
                        onClick={() => {
                            let link = window.screen.width < 900 ? data?.Props?.mobileHrefref : data?.Props?.href
                            if (link && link?.includes("https://")) {
                                window.open(link, '_blank')
                            } else {
                                dispatch(setIsComing(true))
                            }
                        }} />

                    )
                })}</div>
            default:
                return <div />
        }

    }
    const getLeftHeroContent = (components) => {
        return (
            <div className="PapayaHome-Hero-overlay-left">
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getLeftHeroContentComponents(component)
                    )
                })}
            </div>
        )
    }
    const getRightHeroContent = (props) => {
        return (
            <div className="PapayaHome-Hero-overlay-right">
                <div className="PapayaHome-Hero-overlay-right-right">
                    <img className="PapayaHome-Hero-overlay-right-right-img"
                        alt=""
                        src={props?.topSrc} />
                </div>
                <div className="PapayaHome-Hero-overlay-right-left">
                    <img className="PapayaHome-Hero-overlay-right-left-img"
                        alt=""
                        src={props?.bottomSrc} />
                </div>
                <div className="PapayaHome-Hero-overlay-right-img"
                    style={{
                        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5),
            rgba(0, 0, 0, 0.5)), url(${props.src})`
                    }} />
            </div>
        )
    }
    const getHeroComponent = (component) => {
        switch (component.ID) {
            case "PapayaHome-Hero-overlay-left":
                return getLeftHeroContent(component?.Components)
            case "PapayaHome-Hero-overlay-right":
                return getRightHeroContent(component?.Props)
            default:
                return <div />
        }

    }
    const getHeroContent = (components, heroBackground) => {
        return (
            <div className="PapayaHome-Hero">
                <video className='react-video-player'
                    style={{
                        height: "120vh",
                        objectFit: 'cover',
                        width: "100%",
                        backgroundPosition: 'bottom',
                        maxHeight: "120vh"

                    }} autoPlay={true} loop={true} muted={true} controls={false} src={heroBackground} />
                <div className="PapayaHome-Hero-overlay">
                    {sortByOrderAscending(components).map((component, key) => {
                        return (
                            getHeroComponent(component)
                        )
                    })}
                </div>
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "PapayaHome-Hero":
                return getHeroContent(component.Components, component?.Props?.bgSrc)
            case "PapayaHome-Content":
                return getAboutContent(component.Components)
            case "PapayaHome-Content2-List":
                return getHomeContentList(component?.Data)
            case "PapayaHome-Voucher":
                return getVoucherContent(component?.Props?.bgSrc, component.Components)
            case "PapayaHome-Content3":
                return getHomeContent3(component?.Components)
            case "PapayaHome-Content4":
                return getHomeContent4(component?.Components)
            case "PapayaHome-Content5":
                return getHomeContent5(component?.Components)
            case "PapayaHome-Player":
                return getVideoPlayer(component?.Props?.src, component.Data)
            case "PapayaHome-Content6-List":
                return getHomeContent6List(component?.Data)
            case "PapayaHome-Testimonials":
                return getHomeTestimonials(component?.Props?.bgSrc, component.Components)
            case "PapayaHome-ImageCarousel":
                return getImagesCarousel(component.Data)
            default:
                return <div />
        }

    }
    return (
        <div className="PapayaHome">
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
        </div>
    )
}
export default PapayaHome